import { initializeApp, getApps, getApp } from "firebase/app";

let app;

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyChL_O4dEgtQ0RUf8GrdyIeD-znRNPEFWA",
  authDomain: "parados-web-app-1d809.firebaseapp.com",
  projectId: "parados-web-app-1d809",
  storageBucket: "parados-web-app-1d809.appspot.com",
  messagingSenderId: "667606618000",
  appId: "1:667606618000:web:ec3ed810f6cda478556d15"
};

if (getApps().length === 0) {
  // Initialize Firebase app
  app = initializeApp({
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  });
} else {
  // Use existing app if already initialized
  app = getApp();
}

export const firebaseApp = app;
